import {NOT_CONFIGURABLE_COLUMNS} from './constants'

export const isSortByColumnUnavailable = (sortBy, selectedMap) => NOT_CONFIGURABLE_COLUMNS.includes(sortBy) || !selectedMap[sortBy]



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/utils.js